var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-success"},[_c('h2',{staticClass:"contact-dialog__title"},[_vm._v(_vm._s(_vm.$t('title')))]),_vm._v(" "),_c('p',{staticClass:"contact-dialog__intro small"},[_vm._v(_vm._s(_vm.$t('body')))])])}
var staticRenderFns = []

export { render, staticRenderFns }